var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAdMarketing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_426_26744)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 18.6338V19.3671H10.1327V18.6338H8.66602Z",
    fill: "#2497F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.133 8.20642V22.3931C20.133 22.9731 19.813 23.4998 19.293 23.7598C19.073 23.8731 18.833 23.9264 18.5997 23.9264C18.2797 23.9264 17.9663 23.8264 17.6997 23.6331L11.8263 19.3664H10.133V18.6331H8.66634V19.3664H8.46634C6.73967 19.3664 5.33301 17.9598 5.33301 16.2331V14.3664C5.33301 12.6398 6.73967 11.2331 8.46634 11.2331H11.8263L17.6997 6.95975C18.1663 6.61975 18.7797 6.57309 19.293 6.83975C19.813 7.09975 20.133 7.61975 20.133 8.20642Z",
    fill: "#2497F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.1327 18.6338H8.66602V24.8271H10.1327V18.6338Z",
    fill: "#2497F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.0667 14.5664H22.7334V16.0331H26.0667V14.5664Z",
    fill: "#2497F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3892 8.61759L22.0322 10.9746L23.0693 12.0117L25.4263 9.65468L24.3892 8.61759Z",
    fill: "#2497F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.0705 18.5822L22.0332 19.6191L24.3898 21.9766L25.4271 20.9397L23.0705 18.5822Z",
    fill: "#2497F3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_426_26744"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20.7333,
    height: 18.16,
    fill: "white",
    transform: "translate(5.33301 6.66602)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdMarketing);
export default __webpack_public_path__ + "static/media/icon_ad_marketing.eb94e5ee.svg";
export { ForwardRef as ReactComponent };